import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=5272ad1b&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=ts&"
export * from "./Users.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5272ad1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5272ad1b')) {
      api.createRecord('5272ad1b', component.options)
    } else {
      api.reload('5272ad1b', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=5272ad1b&scoped=true&", function () {
      api.rerender('5272ad1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/account/Users.vue"
export default component.exports